import React, { useState } from 'react'
import { PersonalInfoInterface } from '../interfaces'

interface EnergyInfoInterface {
  familySize: number
  consumption: number
  gas: number
}

interface SharedDataInterface {
  personalInfo: PersonalInfoInterface | undefined
  energyInfo: EnergyInfoInterface | undefined
}

const initialContextObject: { data: SharedDataInterface, setPersonalInfo: any, setEnergyInfo: any } = {
  data: {
    personalInfo: undefined,
    energyInfo: undefined
  },
  setPersonalInfo: (personalInfo: PersonalInfoInterface) => {
  },
  setEnergyInfo: (energyInfo: EnergyInfoInterface) => {
  }
}

export const SharedDataContext = React.createContext(initialContextObject)

const SharedDataContextProvider = (props: { children: React.ReactNode }) => {
  const [data, setData] = useState<SharedDataInterface>({
    personalInfo: undefined,
    energyInfo: undefined
  })
  
  const setPersonalInfo = (personalInfo: PersonalInfoInterface) => setData({ ...data, personalInfo })
  const setEnergyInfo = (energyInfo: EnergyInfoInterface) => setData({ ...data, energyInfo })
  
  return (
    <SharedDataContext.Provider value={{ data, setPersonalInfo, setEnergyInfo }}>
      {props.children}
    </SharedDataContext.Provider>
  )
}

export default SharedDataContextProvider
